import { ShimmerElementType } from '@fluentui/react';

export const headerElement = [
  { type: ShimmerElementType.line, height: 20, width: '15%' },
  { type: ShimmerElementType.gap, width: '85%' },
];

export const buttonRowElement = [
  { type: ShimmerElementType.line, height: 20, width: '10%' },
  { type: ShimmerElementType.gap, width: '5%' },
  { type: ShimmerElementType.line, height: 20, width: '10%' },
  { type: ShimmerElementType.gap, width: '5%' },
  { type: ShimmerElementType.line, height: 20, width: '10%' },
  { type: ShimmerElementType.gap, width: '5%' },
  { type: ShimmerElementType.line, height: 20, width: '10%' },
  { type: ShimmerElementType.gap, width: '60%' },
];

export const largeBlockElement = [
  { type: ShimmerElementType.line, height: 60, width: '100%' },
];

export const footerElement = [
  { type: ShimmerElementType.line, height: 20, width: '10%' },
  { type: ShimmerElementType.gap, width: '90%' },
];
